module.exports = __webpack_public_path__ + "img/Lucky_Tooth.60572029.png";